<template>
  <div class="apply-return">
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>物流公司</div>
        <div class="num acea-row row-left">
          <select v-model="expressType">
            <option value="">请选择</option>
            <option
              v-for="(text, index) in expressList"
              :value="text.name"
              :key="index"
            >
              {{ text.name }}
            </option>
          </select>
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
	  <div class="item textarea acea-row row-between">
	    <div>物流单号</div>
	    <input class="danhao" type="text" v-model="expressNum" placeholder="请输入物流单号">
	  </div>
	  <div class="item textarea acea-row row-between">
        <div>物流说明</div>
        <textarea
          placeholder="选填，最多100字"
          class="num"
          v-model="refund_reason_wap_explain"
        ></textarea>
      </div>
      <div class="item acea-row row-between">
        <div class="title acea-row row-between-wrapper">
          <div>上传凭证</div>
          <div class="tip">( 上传物流单号凭证，最多3张 )</div>
        </div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in refund_reason_wap_img"
            :key="img"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="refund_reason_wap_img.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="refund_reason_wap_img.length < 3"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传凭证</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
    </div>
     <button type="button" class="returnBnt bg-color-red displayblock" @click="submit" :disabled="isDisabled">提交</button>
  </div>
</template>

<script>
import { orderDetail, logisticsCompany, postRefundLogistics } from "@api/order";
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
  name: "RefundExpress",
  components: {
    VueCoreImageUpload
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      id: this.$route.params.id || 0,
      expressList: [],
      expressType: "",
	  expressNum:"",
      refund_reason_wap_explain: "",
      refund_reason_wap_img: [],
      isDisabled:false
    };
  },
  mounted() {
  	this.getLogisticsCompany();
  },
  methods: {
	getLogisticsCompany(){
	  let that = this;
	  logisticsCompany().then(res => {
		that.expressList = res.data;
	  }).catch(err => {
		that.$dialog.error(err.msg);
	  });
	},
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.data.url);
    },
    submit() {
	  let that = this;
      const refund_reason_wap_explain = trim(that.refund_reason_wap_explain),
        text = that.expressType;
      if (!text) return that.$dialog.toast({ mes: "请选择物流公司" });
      if (!that.expressNum) return that.$dialog.toast({ mes: "请填写物流单号" });
      that.isDisabled = true;
      postRefundLogistics({
		refunds_id: that.$route.params.id,
		delivery_name: text,
		delivery_id: that.expressNum,
        delivery_voucher: that.refund_reason_wap_img.join(","),
        delivery_reason: refund_reason_wap_explain
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.$router.go(-1);
        })
        .catch(res => {
          that.isDisabled = false;
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>
<style scoped>
.line2 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.list{margin-top: 0;}
.danhao{text-align: right;}
.danhao::placeholder{color:#666;}
</style>
